<template>
  <div>
    <CustodianBankIndexMobile
      v-if="isMobile"
      :other-links="$options.otherLinks"
      :page-description="$options.pageDescription"
      :base-url="$options.baseUrl"
      :content-data="$options.contentData"
    />
    <CustodianBankIndexDesktop
      v-else
      :other-links="$options.otherLinks"
      :page-description="$options.pageDescription"
      :base-url="$options.baseUrl"
      :content-data="$options.contentData"
      :breadcrumb-links="$options.breadcrumbLinks"
    />
  </div>
</template>

<script>
import {
  getCustodianBankObject,
  generateOtherLinks,
  generateBreadcrumbLinks,
  seoMapperConstant as CONSTANT,
} from 'shared/helpers/seoMap';
import isMobile from 'shared/mixins/isMobile';
import CustodianBankIndexMobile from '../../components/mobile/custodian_bank/CustodianBankIndex';
import CustodianBankIndexDesktop from '../../components/desktop/custodian_bank/CustodianBankIndex';

const mutualFundCustodianBankObject = getCustodianBankObject();

export default {
  name: 'CustodianBankIndexPage',
  metaInfo() {
    return {
      title: mutualFundCustodianBankObject.meta_title,
      meta: [
        { name: 'description', content: mutualFundCustodianBankObject.meta_desc },
        { name: 'keyword', content: mutualFundCustodianBankObject.meta_keyword },
      ],
    };
  },
  components: {
    CustodianBankIndexMobile,
    CustodianBankIndexDesktop,
  },
  mixins: [isMobile],
  otherLinks: generateOtherLinks(CONSTANT.CUSTODIAN_BANK_KEY),
  pageDescription: mutualFundCustodianBankObject.page_desc,
  baseUrl: mutualFundCustodianBankObject.link_url,
  contentData: mutualFundCustodianBankObject.data,
  breadcrumbLinks: generateBreadcrumbLinks(CONSTANT.CUSTODIAN_BANK_KEY),
};
</script>
